import { useSearchParams } from '@remix-run/react'
import { Checkbox } from '#app/shared/ui/inputs/Checkbox.js'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'
import { RangeInput } from './rangeInput'

type FilterPrecioCuotaProps = {
  deducibleIvaCount: number
}

export const FilterPrecioCuota = ({
  deducibleIvaCount,
}: FilterPrecioCuotaProps): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams()
  const EuroSuffix = () => <div className="text-foreground-muted">€</div>

  const handleCheckboxChange = (checked: boolean) => {
    const currentParams = Object.fromEntries(searchParams.entries())
    const updatedParams = { ...currentParams }

    if (checked) {
      updatedParams.deducibleIva = 'true'
    } else {
      delete updatedParams.deducibleIva
    }

    setSearchParams(updatedParams)
  }

  return (
    <MainContainer>
      <div
        className={`
          flex max-w-[72%] flex-col justify-between gap-6 px-2 py-4

          lg:flex-row lg:gap-24
        `}
      >
        <RangeInput
          title="Precio"
          minParamName="priceMin"
          maxParamName="priceMax"
          suffix={<EuroSuffix />}
        />

        <div className="flex flex-col gap-2">
          <h3 className="mb-4 text-base-bold">IVA deducible</h3>
          <div className="flex flex-col justify-center">
            <div className="flex items-center gap-2">
              <Checkbox
                id="deducibleIva"
                checked={searchParams.get('deducibleIva') === 'true'}
                onCheckedChange={(checked) => handleCheckboxChange(!!checked)}
              />
              <label
                htmlFor="deducibleIva"
                className={`
                  whitespace-nowrap pr-16 text-base-medium text-neutral-700
                `}
              >
                Si ({deducibleIvaCount})
              </label>
            </div>
          </div>
        </div>

        <RangeInput
          title="Cuota de financiación"
          minParamName="financingMin"
          maxParamName="financingMax"
          suffix={<EuroSuffix />}
        />
      </div>
    </MainContainer>
  )
}
